import { render, staticRenderFns } from "./AdminSocietesInit.vue?vue&type=template&id=30d876b0&scoped=true"
import script from "./AdminSocietesInit.vue?vue&type=script&lang=js"
export * from "./AdminSocietesInit.vue?vue&type=script&lang=js"
import style0 from "./AdminSocietesInit.vue?vue&type=style&index=0&id=30d876b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d876b0",
  null
  
)

export default component.exports